<template>
    <div style="position:relative; top:150px;">
        <content-header
            icona="fas fa-graduation-cap"
            titolo="Corsi"
        ></content-header>

        <div class="card sn-card-contenuto">
            <div class="card-body">

                <!-- ******** CORSI PRENOTATI ******** -->
                <!-- ********************************* -->
                <div class="row rigaSezioneForm">
                    <div class="col-md">
                        <h3><i class="fas fa-history text-primary"></i>&nbsp;Corsi prenotati</h3>
                    </div>
                </div>

                <button type="button" class="btn btn-dark" @click="GetListCorsiPrenotazioni()">
                    <i class="fas fa-sync"></i>&nbsp;
                </button>&nbsp;
                
                <br /><br />

                <!-- **** GRIGLIA CORSI PRENOTATI **** -->
                <table class="table table-sm table-custom">
                    <thead>
                        <tr>
                            <th>Id. pren.</th>
                            <th>Titolo corso</th>
                            <th>Data Prenotazione</th>
                            <th>Partecipanti</th>
                            <th>Stato</th>
                            <th>Note</th>
                            <th><i class="fas fa-bars fa-fw"></i></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="p, i in ViewPrenotazioni()" :key="i">
                            <td>{{ p.cpr_id }}</td>
                            <td>{{ p.cct_titolo }}</td>
                            <td>{{ FormattaData(p.cpr_dtaPrenota) }}</td>
                            <td>{{ p.cpr_npartecipanti }}</td>
                            <td>{{ p.cps_descrizione }}</td>
                            <td>{{ p.cpr_note }}</td>
                            <td>
                                <!-- <button type="button" class="btn btn-sm btn-outline-primary" title="Modifica" @click="EditPersonale(p.cpr_id)"><i class="fas fa-edit" title="Edit"></i></button>&nbsp; -->
                                <button type="button" v-if="p.cpr_stato !=3 && p.cpr_stato !=2 " class="btn btn-sm btn-outline-warning me-2" title="Annulla" @click="AnnullaCorsiPrenotazioni(p.cpr_id)"><i class="fas fa-ban fa-fw"></i></button>
                                <button type="button" v-if="p.cpr_stato == 4 " class="btn btn-sm btn-outline-primary me-2" title="Carica personale e finalizza" @click="StartFinalizza(p)"><i class="fas fa-users fa-fw"></i></button>
                                <button type="button" v-if="p.cpr_stato == 5 " class="btn btn-sm btn-outline-primary me-2" title="Modifica richiesta" @click="ModificaRichiesta(p)"><i class="fas fa-edit fa-fw"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <br /><br />


                <!-- ******** ARCHIVIO CORSI ********* -->
                <!-- ********************************* -->
                <div class="row rigaSezioneForm">
                    <div class="col-md">
                        <h3><i class="fas fa-archive text-primary"></i>&nbsp;Archivio corsi</h3>
                    </div>
                </div>

                <!-- <button type="button" class="btn btn-dark" @click="GetListCorsi()">
                    <i class="fas fa-sync"></i>&nbsp;
                </button>&nbsp; 
                
                <br /><br />-->


                <!-- Filtro:  2, 3, 6-->
                <button type="button" class="btn btn-sm btn-outline-dark me-2" data-bs-toggle="button" autocomplete="off" :class="{'active': aFiltroArchivio[0]}" @click="ToggleFiltro(0)">Rifiutata</button>
                <button type="button" class="btn btn-sm btn-outline-dark me-2" data-bs-toggle="button" autocomplete="off" :class="{'active': aFiltroArchivio[1]}" @click="ToggleFiltro(1)">Annullata dal Cliente</button>
                <button type="button" class="btn btn-sm btn-outline-dark me-2" data-bs-toggle="button" autocomplete="off" :class="{'active': aFiltroArchivio[2]}" @click="ToggleFiltro(2)">Calendarizzata</button>
                
                

                <!-- **** GRIGLIA ARCHIVIO CORSI **** -->
                <table class="table table-sm table-custom">
                    <thead>
                        <tr>
                            <th>Id. pren.</th>
                            <th>Titolo corso</th>
                            <th>Data Prenotazione</th>
                            <th>Partecipanti</th>
                            <th>Stato</th>
                            <th>Note</th>
                            <th><i class="fas fa-bars fa-fw"></i></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="p, i in ViewArchivio()" :key="i">
                            <td>{{ p.cpr_id }}</td>
                            <td>
                                <span v-if="p.cpr_stato == 6">
                                    {{ p.cor_titolo }} - cod. corso [{{ p.cor_codice }}]
                                </span>
                                <span v-else>{{ p.cct_titolo }} </span>
                            </td>
                            <td>
                                <span v-if="p.cpr_stato == 6">
                                    Svolgimento:<br />
                                    dal {{ p.cor_dta_inizio }} al {{ p.cor_dta_fine }}</span>
                                <span v-else>{{ FormattaData(p.cpr_dtaPrenota) }}</span>
                                
                            </td>
                            <td>{{ p.cpr_npartecipanti }}</td>
                            <td>{{ p.cps_descrizione }}</td>
                            <td>{{ p.cpr_note }}</td>
                            <td>
                                <template v-if="p.cpr_stato == 6">
                                    <button class="btn btn-sm btn-outline-primary disabled" title="Esiti"><i class="fas fa-chart-bar"></i></button>

                                </template>
                            </td>
                        </tr>
                    </tbody>
                </table>

            
                

            </div>
        </div>

    </div>
  
    


    <!-- *** DIALOG FINALIZZA PRENOTAZIONE *** -->
    <dialog class="dialogGilettaFinalizza">
        <div class="d-flex mb-3" style="border-bottom:solid 1px #ccc" >
            <div class="">
                <i class="fas fa-shopping-cart text-primary"></i>
            </div>
            <div class="ms-2">
                <h5>Finalizzazione prenotazione</h5>
            </div>
        </div>

        <div class="mb-2 mt-2">
            Scegli i partecipanti del corso
        </div>

        <div class="row mb-2">
            <div class="col-md-10">
                <select class="form-control" v-model="addPersonale">
                    <option v-for="p, i in dtPersonale" :key="i" :value="i">{{ p.per_cognome }} {{ p.per_nome }}</option>
                </select>
            </div>
            <div class="col-md-2">
                <button type="button" class="btn btn-outline-success" @click="AggiungiPersonale"><i class="fas fa-plus"></i>&nbsp;Aggiungi</button>
            </div>
        </div>

        <table class="table table-sm table-custom">
            <thead>
                <tr>
                    <th>Id</th>
                    <th>Cognome</th>
                    <th>Nome</th>
                    <th><i class="fas fa-bars fa-fw"></i></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="pa, i in oFinalizza.personale" :key="i">
                    <td>{{ pa.per_id }}</td>
                    <td>{{ pa.per_cognome }}</td>
                    <td>{{ pa.per_nome }}</td>
                    <td>
                        <button type="button" class="btn btn-sm btn-outline-danger me-2" title="Cancella" @click="CancellaPersonale(i)"><i class="fas fa-trash fa-fw"></i></button>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-outline-dark me-2" @click="ChiudiFinalizza">Annulla</button>
            <button type="button" class="btn btn-outline-primary" @click="FinalizzaRichiesta"><i class="fas fa-chevron-right"></i>&nbsp;Finalizza</button>
        </div>


    </dialog>
       
    
</template>

<script>
import snFunctions from '@/lib/snFunctions.js';
import MessaggioStandard from '@/components/MessaggioStandard.vue';
import ContentHeader from '@/components/layout/ContentHeader.vue';

export default {
    name: 'CorsiView',
    components: {
        ContentHeader
    },
    inject: ['cfg'],
    data: function() {
        return {

            dtCorsiPrenotazioni: [],
            dtPersonale: [],

            addPersonale: -1,

            oFinalizza: {
                idCpr: -1,
                personale: [],
            },

            aFiltroArchivio: [false, false, true],
           

        }
    },
    methods: {
        // ***  Prenotazioni *** //
        GetListCorsiPrenotazioni() {
            //Carica lista elementi
            fetch(this.cfg.apisrv + "/api/CorsiPrenotazioni/GetListCorsiPrenotazioni?token=" + this.$store.state.UserInfo.token + "&idAna=" + this.$store.state.UserInfo.id)
                .then(response => response.json())
                .then(obj => {
                    this.dtCorsiPrenotazioni = obj;
                });
        },
        AnnullaCorsiPrenotazioni(idelem) {
            if(confirm("Annullare questa prenotazione?")) {
                fetch(this.cfg.apisrv + "/api/CorsiPrenotazioni/AnnullaCorsiPrenotazioni?token=" + this.$store.state.UserInfo.token + "&idCpr=" + idelem)
                .then(response => response.json())
                .then(obj => {
                    this.GetListCorsiPrenotazioni();
                });
            }

        },


        // *** Processo finalizzazione e modifica personale *** //
        StartFinalizza(o) {
            this.oFinalizza.idCpr = o.cpr_id;
            this.oFinalizza.personale = [];

            const dialog = document.querySelector(".dialogGilettaFinalizza");
            dialog.showModal();
        },
       
        ChiudiFinalizza() {
            const dialog = document.querySelector(".dialogGilettaFinalizza");
            dialog.close();
        },
        AggiungiPersonale() {
            for(let i=0; i<this.dtPersonale.length; i++) {
                if(i == this.addPersonale && !this.oFinalizza.personale.includes(this.dtPersonale[i])) {
                    this.oFinalizza.personale.push(this.dtPersonale[i]);
                }
            }
        },
        CancellaPersonale(ndx) {
            this.oFinalizza.personale.splice(ndx, 1);
        },
        FinalizzaRichiesta() {
            let oSubmit = [];
            oSubmit = this.oFinalizza;
            oSubmit.token = this.$store.state.UserInfo.token;
                  
            this.$store.commit('Messaggio', {parms: [true, ['Salvataggio in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
            fetch(this.cfg.apisrv + "/api/CorsiPrenotazioni/FinalizzaCorsiPrenotazioni", {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(oSubmit)
            }).then(response => response.json())
                .then(obj => {
                    if (obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Salvataggio effettuato.'], 'alert alert-success', 'fa-check', false, 2000]});

                        this.ChiudiFinalizza();
                        this.GetListCorsiPrenotazioni();
                     
                    }
                    else {
                        this.$store.commit('Messaggio', {parms: [true, obj.dati, 'alert alert-warning', 'fa-times', false, 3000]});

                    }
                });


        },
        ModificaRichiesta(o) {
            this.oFinalizza.idCpr = o.cpr_id;
            this.oFinalizza.personale = [];

            //Carica lista partecipanti
            fetch(this.cfg.apisrv + "/api/CorsiPrenotazioni/GetListPartecipanti?token=" + this.$store.state.UserInfo.token + "&idCpr=" + o.cpr_id)
                .then(response => response.json())
                .then(obj => {

                    this.oFinalizza.personale = obj;


                    const dialog = document.querySelector(".dialogGilettaFinalizza");
                    dialog.showModal();
                    
                });

            
        },

        /* Filtro griglia archivio  */
        ToggleFiltro(i) {
            this.aFiltroArchivio[i] = !this.aFiltroArchivio[i];
        },


        /* *** TABELLE DI SERVIZIO *** */
        GetListPersonale() {
            //Carica lista elementi
            fetch(this.cfg.apisrv + "/api/Personale/GetListPersonale?token=" + this.$store.state.UserInfo.token + "&idAna=" + this.$store.state.UserInfo.id)
                .then(response => response.json())
                .then(obj => {
                    this.dtPersonale = obj;
                });
        },

        //****** VIEWS e FILTRI ***** */
        ViewPrenotazioni() {
            return this.dtCorsiPrenotazioni.filter((p) => p.cpr_stato == 1 | p.cpr_stato == 4 | p.cpr_stato == 5 );
        },

        ViewArchivio() {
            //return this.dtCorsiPrenotazioni.filter((p) => (p.cpr_stato == 2 | p.cpr_stato == 3 | p.cpr_stato == 6));
            // Mappatura degli stati: indice 0 => 2, indice 1 => 3, indice 2 => 6
            let mappingStati = [2, 3, 6];

            // Seleziona gli stati per cui il filtro è attivo (true)
            let statiSelezionati = mappingStati.filter((stato, index) => this.aFiltroArchivio[index]);

            // Filtra i dati in base agli stati selezionati
            let risultato = this.dtCorsiPrenotazioni.filter(p => statiSelezionati.includes(p.cpr_stato));

            return risultato;
        },


       
        /* *** ALTRE FUNZIONI *** */
        FormattaData(dta) {
            return snFunctions.dateFormat(dta, "dd-MM-yyyy");
        },

    },
    mounted: function() {
        if(this.$store.state.UserInfo.token == '') this.$router.push("/");

        this.GetListCorsiPrenotazioni();
        this.GetListPersonale();
        

    }
}
</script>